<template>
  <div class="myDeclareCertProfile">
    <van-nav-bar
      class="nav_bar"
      title="我的报证"
      left-arrow
      placeholder
      @click-left="$router.back()"
    />
    <van-form
      ref="validateForm"
      validate-first
      input-align="right"
      :show-error="false"
      :show-error-message="false"
    >
      <van-field
        required
        v-model.trim="userInfo.currAddress"
        label="邮寄地址"
        maxlength="50"
        placeholder="请输入邮寄地址"
        :rules="[{ required: true, message: '请输入邮寄地址' }]"
      />
      <van-field
        required
        v-model.trim="userInfo.workUnit"
        label="单位"
        maxlength="50"
        placeholder="请输入单位"
        :rules="[{ required: true, message: '请输入单位' }]"
      />
      <van-field
        required
        label="证件照"
        class="photo_wrap"
        readonly
        :rules="[
          { validator: () => !!userInfo.idPhoto, message: '请上传证件照' },
        ]"
      >
        <template #input>
          <div class="photo_box">
            <van-uploader
              accept=".jpg,.jpeg"
              :before-read="beforeRead"
              :after-read="afterRead"
            >
              <div class="avtar">
                <img
                  :src="
                    userInfo.idPhoto ||
                    require('../../../assets/images/account/userdefault2.png')
                  "
                  alt=""
                />
              </div>
            </van-uploader>
          </div>
        </template>
      </van-field>
      <div class="handle_btn">
        <van-button
          round
          block
          plain
          type="info"
          class="cancel_btn"
          @click="cancelHandle"
          >取消</van-button
        >
        <van-button round block type="info" class="save_btn" @click="saveHandle"
          >保存</van-button
        >
      </div>
    </van-form>
  </div>
</template>

<script>
export default {
  name: "myDeclareCertProfile",
  data() {
    return {
      userId: "",
      userInfo: {
        userId: "",
        currAddress: "",
        workUnit: "",
        idPhoto: "",
      },
    };
  },
  async mounted() {
    const userInfoRes = await this.$api.usercenter.findUser();
    if (userInfoRes.success) {
      this.userId = userInfoRes.data.id;
    }
    this.getReportInfo();
  },
  methods: {
    getReportInfo() {
      this.$api.usercenter.findReport({ userId: this.userId }).then((res) => {
        if (res.success) {
          for (const key in res.data) {
            if (Object.hasOwnProperty.call(res.data, key)) {
              const element = res.data[key];
              if (Object.hasOwnProperty.call(this.userInfo, key))
                this.userInfo[key] = element;
            }
          }
        }
      });
    },
    beforeRead(file) {
      console.log(file);
      const nameArr = file.name.split(".");
      if (
        file.type !== "image/jpeg" ||
        (nameArr && !["jpg","jpeg","JPG","JPEG"].includes(nameArr[nameArr.length - 1]))
      ) {
        this.$notify({
          duration: 2000,
          type: "danger",
          message: "请上传jpg图片",
        });
        return false;
      }
      if (file.size / 1024 > 150) {
        this.$notify({
          duration: 2000,
          type: "danger",
          message: "图片不能大于150KB",
        });
        return false;
      }
      return true;
    },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      let formData = new FormData();
      formData.append("file", file.file);
      this.$api.user
        .upload(formData)
        .then(async (res) => {
          if (res.code == 0) {
            file.status = "";
            file.message = "";
            this.userInfo.idPhoto = res.data;
          }
        })
        .catch((err) => {
          file.status = "failed";
          file.message = "上传失败";
        });
    },
    cancelHandle() {
      this.$router.go(-1);
    },
    //保存
    saveHandle() {
      this.$refs.validateForm
        .validate()
        .then(() => {
          const data = { ...this.userInfo, userId: this.userId };
          console.log(data);
          this.$api.usercenter.saveReport(data).then((res) => {
            if (res.success) {
              this.$toast({
                message: "保存成功",
              });
              this.$router.go(-1);
            }
          });
        })
        .catch((error) => {
          console.log(error);
          this.$toast({
            message: error[0].message,
          });
        });
    },
  },
};
</script>

<style scoped lang="stylus">
.myDeclareCertProfile {
  /deep/ .van-cell {
    min-height: 2.773rem;
    padding-left: 1.2rem;
    padding-right: 0.8rem;
    display: flex;
    align-items: center;
  }

  /deep/ .van-cell--required::before {
    left: 0.8rem;
  }

  .photo_box {
    text-align: center;

    .avtar {
      position: relative;
      width: 200px;
      height: 260px;
      margin: 0 auto;
      border-radius: 16px;
      // margin-bottom :36px;
      overflow: hidden;

      .uploadLoading {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background-color: rgba(255, 255, 255, 0.6);
        border-radius: 50%;
        text-align: center;

        /deep/ .van-loading__spinner {
          margin-top: 25px;
        }
      }

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .handle_btn {
    width: 750px;
    height: 112px;
    background: #ffffff;
    box-shadow: 0px 1px 0px 0px #eaeaea;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 48px;

    .cancel_btn {
      width: 332px;
      height: 88px;
      border-radius: 50px;
      border: 1px solid #1972ff;
      margin-right: 26px;
      color: #1972ff;
      font-size: 32px;
    }

    .save_btn {
      width: 332px;
      height: 88px;
      background: #1972ff;
      border-radius: 50px;
      font-size: 32px;
      color: #ffffff;
    }
  }
}
</style>